import { initializeApp } from "firebase/app";
import { getMessaging, Messaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBycXwe3vHj6wlutZyat5B908ZILaS-6Jg",
  authDomain: "desh-apnayen.firebaseapp.com",
  projectId: "desh-apnayen",
  storageBucket: "desh-apnayen.firebasestorage.app",
  messagingSenderId: "1016763307767",
  appId: "1:1016763307767:web:9dba009f832ff95d2925f2",
  measurementId: "G-RRGBJZX8N8",
};

const app = initializeApp(firebaseConfig);

// Avoid SSR crash
export const messaging: Messaging | null =
  typeof window !== "undefined" ? getMessaging(app) : null;
